namespace TabAurous.Scheme {

    @Serenity.Decorators.registerEditor()
    export class SchemeEnrollmentEditor extends Serenity.Select2Editor<Serenity.LookupEditorOptions, Scheme.SchemeMasterRow> {

        constructor(container: JQuery, options: Serenity.LookupEditorOptions) {
            super(container, options);
           
        }

        //protected getLookupKey() {
        //    return Scheme.SchemeMasterRow.;
        //}

        //protected getItemText(item: Scheme.SchemeMasterRow, lookup: Q.Lookup<Scheme.SchemeMasterRow>)
        //{
        //    return super.getItemText(item, lookup)

        //        //+

        //        //+  item.Code + '-' + item.Description;
                
        //}


    }
}